import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureName } from './auth.state';
import { reducer } from './auth.reducer';

@NgModule({
  imports: [StoreModule.forFeature(featureName, reducer)]
})
export class AuthStoreModule {}
